import { FC } from 'react';
import cn from 'classnames';

import { IStatusCountProps, TStatusCountIcon } from './StatusCount.interface';

import './style.scss';

const StatusCount: FC<IStatusCountProps> = ({ className, icon, count, children }) => (
  <div
    className={cn(
      'status-count',
      {
        'status-count_red': icon === TStatusCountIcon.Red,
        'status-count_yellow': icon === TStatusCountIcon.Yellow,
        'status-count_blue': icon === TStatusCountIcon.Blue,
      },
      className,
    )}
  >
    <div className="status-count__number">{count}</div>
    {children && <div className="status-count__text">{children}</div>}
  </div>
);

export default StatusCount;
